/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import styles from "./index.module.scss";

const Simple = forwardRef(function Simple(props, ref) {
  const { settings, children, mouseWheel } = props;

  const [parentElement, setParentElement] = useState(null);
  const [sliderElement, setSliderElement] = useState(null);

  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({
    slider: sliderElement?.innerSlider,
    goToSlide(index) {
      sliderElement && sliderElement.slickGoTo(index);
    },
  }));

  useEffect(() => {
    if (!parentElement) {
      return;
    }

    if (parentElement && mouseWheel) {
      //only use mouse scroll in desktop screen
      parentElement.addEventListener("wheel", (e) => handleScroll(e));
    }
    return () => {
      parentElement.removeEventListener("wheel", (e) => handleScroll(e));
    };
  }, [parentElement, mouseWheel]);

  const handleScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.deltaY > 0) {
      sliderElement && sliderElement.slickNext();
    } else if (e.deltaY < 0) {
      sliderElement && sliderElement.slickPrev();
    }
  };

  return (
    <>
      <div
        ref={(el) => {
          if (!el) return;
          setParentElement(el);
        }}
        className="relative h-full w-full"
      >
        <Slider
          className={styles["g-slider-simple"]}
          {...settings}
          ref={(el) => {
            if (!el) return;
            setSliderElement(el);
          }}
        >
          {children}
        </Slider>
      </div>
    </>
  );
});

Simple.propTypes = {
  settings: PropTypes.object,
  mouseWheel: PropTypes.bool,
};

Simple.defaultProps = {
  settings: {},
  mouseWheel: false,
};

export default Simple;
